export default "__VITE_ASSET__ClDEtV59__"